import { Action } from '@ngrx/store';

export const SET_FILTERED_RESULTS_CONFIG = '[CompanyAnalysis] SET_FILTERED_RESULTS_CONFIG';
export const CLEAR_FILTERED_RESULTS_CONFIG = '[CompanyAnalysis] CLEAR_FILTERED_RESULTS_CONFIG';

export const SET_USER_COLUMNS = '[CompanyAnalysis] SET_USER_COLUMNS';
export const CLEAR_USER_COLUMNS = '[CompanyAnalysis] CLEAR_USER_COLUMNS';

export const FETCH_ANALYSIS = '[CompanyAnalysis] FETCH_ANALYSIS';
export const FETCH_ANALYSIS_SUCCESS = '[CompanyAnalysis] FETCH_ANALYSIS_SUCCESS';
export const FETCH_ANALYSIS_FAILURE = '[CompanyAnalysis] FETCH_ANALYSIS_FAILURE';
export const CLEAR = 'CLEAR';

export class Clear implements Action {
  readonly type = CLEAR;
  constructor() { }
}

export class SetFilteredResultsConfig implements Action {
  readonly type = SET_FILTERED_RESULTS_CONFIG;
  constructor(public payload: any) { }
}

export class ClearFilteredResultsConfig implements Action {
  readonly type = CLEAR_FILTERED_RESULTS_CONFIG;
  constructor() { }
}


export class FetchAnalysis implements Action {
  readonly type = FETCH_ANALYSIS;
  constructor(public payload: any) { }
}

export class FetchAnalysisSuccess implements Action {
  readonly type = FETCH_ANALYSIS_SUCCESS;
  constructor(public payload: any) {
  }
}

export class FetchAnalysisFailure implements Action {
  readonly type = FETCH_ANALYSIS_FAILURE;
  constructor(public payload: any) {
  }
}

export type Actions = Clear | FetchAnalysis | FetchAnalysisSuccess | FetchAnalysisFailure
| SetFilteredResultsConfig | ClearFilteredResultsConfig;



// WEBPACK FOOTER //
// ./src/actions/company-analysis.actions.ts